import styled from 'styled-components';
import React from 'react';
import { CloseButton as CloseButtonUnstyled } from '@common/components/CloseButton';

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 25px;
  right: 15px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const CloseButtonStyled = styled(CloseButtonUnstyled)`
  top: initial;
  left: initial;
  right: initial;
  position: absolute;
  border: none;
  background: none;
  color: black;
  opacity: 0.6;

  ::after,
  ::before {
    height: 20px;
  }
`;

export const CloseButton = ({ setClose }) => (
  <CloseButtonWrapper>
    <CloseButtonStyled aria-label="close picker button" onClick={setClose} color="black" />
  </CloseButtonWrapper>
);
